import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { Link } from 'react-router-dom'
import Prismic from 'prismic-javascript'

import Page from '../../components/Page'

import './style.css'

const apiEndpoint = 'https://buda-vet.cdn.prismic.io/api/v2'
const MAX_PAGE_SIZE = 100

class News extends Component {
  state = {
    news: [],
  }

  async componentDidMount() {
    const api = await Prismic.getApi(apiEndpoint)

    const createQuery = typeName => [
      Prismic.Predicates.at('document.type', typeName),
      { pageSize: MAX_PAGE_SIZE },
    ]
    api.query(...createQuery('hir')).then(apiResult => {
      this.setState({
        news: apiResult.results.map(newsItem => ({
          ...newsItem.data,
          id: newsItem.id,
        })),
      })
    })
  }

  render() {
    return (
      <Page title="Hirek" noHero>
        <div className="sectionTitle">Hírek</div>
        <Grid className="News">
          <Row>
            {this.state.news.map(newsItem => (
              <Col xs={12} key={newsItem.id}>
                <Link to={`/hirek/${newsItem.id}`}>
                  <div className="item">
                    <div className="content">
                      <div className="title">{newsItem.cim}</div>
                      <div className="description">
                        {newsItem['rovid-leiras']}
                      </div>
                      <div className="footer">
                        {newsItem.datum} - {newsItem.szerzo}
                      </div>
                    </div>
                    <div
                      className="image"
                      style={{ backgroundImage: `url(${newsItem.fokep.url})` }}
                    />
                  </div>
                </Link>
              </Col>
            ))}
          </Row>
        </Grid>
      </Page>
    )
  }
}

export default News



// WEBPACK FOOTER //
// ./src/pages/News/index.js